var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNounCafe6974749(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5.0 -10.0 110.0 135.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "m78.125 46.875c-2.3945 0-4.6094 0.71094-6.5117 1.8828-0.48047-1.1094-1.5781-1.8828-2.8633-1.8828h-56.25c-1.7266 0-3.125 1.3984-3.125 3.125 0 17.23 14.02 31.25 31.25 31.25 11.434 0 21.426-6.1914 26.871-15.379 2.1992 3.5859 6.1211 6.0039 10.629 6.0039 6.8945 0 12.5-5.6055 12.5-12.5s-5.6055-12.5-12.5-12.5zm0 18.75c-3.4453 0-6.25-2.8047-6.25-6.25s2.8047-6.25 6.25-6.25 6.25 2.8047 6.25 6.25-2.8047 6.25-6.25 6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "m27.625 37.5c0-5.7734 2.5938-8.4766 5.8828-11.898 3.5664-3.7188 7.6172-7.9375 7.6172-16.227 0-1.7266-1.3984-3.125-3.125-3.125s-3.125 1.3984-3.125 3.125c0 5.7734-2.5938 8.4766-5.8828 11.898-3.5664 3.7188-7.6172 7.9375-7.6172 16.227 0 1.7266 1.3984 3.125 3.125 3.125s3.125-1.3984 3.125-3.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "m56.75 6.25c-1.7266 0-3.125 1.3984-3.125 3.125 0 3.8867-1.707 5.6641-4.0703 8.125-2.5859 2.6953-5.8047 6.0469-5.8047 12.445 0 1.7266 1.3984 3.125 3.125 3.125s3.125-1.3984 3.125-3.125c0-3.8828 1.707-5.6641 4.0664-8.1211 2.5898-2.6914 5.8086-6.0469 5.8086-12.449 0-1.7266-1.3984-3.125-3.125-3.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "m68.75 93.75c1.7266 0 3.125-1.3984 3.125-3.125s-1.3984-3.125-3.125-3.125h-56.25c-1.7266 0-3.125 1.3984-3.125 3.125s1.3984 3.125 3.125 3.125z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounCafe6974749);
export default __webpack_public_path__ + "static/media/noun-cafe-6974749.9c0db49267c14270401f0b6eb026b220.svg";
export { ForwardRef as ReactComponent };